// extracted by mini-css-extract-plugin
module.exports = {"btnsWrap":"Invalid_btnsWrap_7tmbQ"};